/**
 * Constant: Icon sizes in pixels, each backed by an icon--size rule in mat-icons.scss
 */
export const IconSize = {
  Size12: '12',
  Size16: '16',
  Size20: '20',
  Size24: '24',
  Size32: '32',
  Size36: '36',
  Size48: '48',
  Size64: '64',
  Size72: '72',
  Size96: '96',
  Size240: '240',
} as const;
export type IconSize = (typeof IconSize)[keyof typeof IconSize];

/**
 * Constant: Icon colours, each backed by an icon--color rule in mat-icons.scss
 */
export const IconColor = {
  Success: 'success',
  Broker: 'broker',
  Insurer: 'insurer',
  Platform: 'platform',
  Info: 'info',
  Danger: 'danger',
  Warning: 'warning',
  Accent: 'accent',
  Gray: 'gray',
  Inherit: 'inherit',
} as const;
export type IconColor = (typeof IconColor)[keyof typeof IconColor];
